module.exports = __webpack_public_path__ + "static/colorpalette-ab04a9040091c80508e9f68b3fe03d5b.jpg";